import { isSaaS } from './isSaaS';

/**
 * Возвращает название приложения в зависимости от типа окружения
 * @returns 'Tender' для SaaS, 'S.Tender' для не-SaaS
 */
export const getAppName = (): string => {
  return isSaaS() ? 'Tender' : 'S.Tender';
};
